import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode } from '@angular/core';
import { CategoryProviderModule } from './categoryprovider.module';
platformBrowserDynamic().bootstrapModule(CategoryProviderModule);
